import { useQuery } from '@tanstack/react-query';
import {
    DP_ACCESS_DENIED_CODE,
    vacationDpBoardService,
} from '../../services/vacationDpBoardService';
import type { VacationDpRow } from '../../models/vacationDpBoard.types';

export const VACATION_DP_BOARD_QUERY_KEY = 'vacationDpBoard';

export function useVacationDpBoardQuery() {
    const queryResult = useQuery({
        queryKey: [VACATION_DP_BOARD_QUERY_KEY],
        queryFn: async (): Promise<VacationDpRow[]> => vacationDpBoardService.getBoardRows(),
        staleTime: 5 * 60 * 1000,
        retry: (failureCount, error) =>
            !isAccessDeniedError(error) && failureCount < 2,
    });

    return {
        rows: queryResult.data ?? [],
        isLoading: queryResult.isLoading,
        error: queryResult.error,
        isAccessDenied: isAccessDeniedError(queryResult.error),
    };
}

function isAccessDeniedError(error: unknown): boolean {
    return error instanceof Error && error.message.startsWith(DP_ACCESS_DENIED_CODE);
}
